import React from "react";
import { CrButton } from "./CrButton";
import { CrIconButton } from "./CrIconButton";
import { CrYear } from "./CrYear";
import { CrYearDateLabel } from "./CrYearInput";
import dayjs from "dayjs";

export interface CrYearExtProps {
  selectedYear?: number;
  minDate?: Date | number | "TODAY";
  maxDate: Date | number | "TODAY";
  dateLabel?: CrYearDateLabel;
  allUnknowable: boolean;
  yearUnknowable: boolean;

  onValueChange: (val: string) => void;
  onDeleteDate: () => void;
  onDismiss?: () => void;
}

export function CrYearExt(props: CrYearExtProps) {
  const { minDate, maxDate, allUnknowable, yearUnknowable, onValueChange, onDeleteDate } = props;

  const curYearSelectable = (() => {
    const maxVal =
      maxDate instanceof Date
        ? dayjs(maxDate.getTime()).format("YYYY")
        : typeof maxDate === "number"
        ? dayjs().add(maxDate, "days").format("YYYY")
        : dayjs().format("YYYY");

    const minVal =
      minDate instanceof Date
        ? dayjs(minDate.getTime()).format("YYYY")
        : typeof minDate === "number"
        ? dayjs().subtract(minDate, "days").format("YYYY")
        : dayjs().format("YYYY");

    return maxVal >= dayjs().format("YYYY") && minVal <= dayjs().format("YYYY");
  })();

  return (
    <div className="cr-calendar-ext">
      <CrYear onSelectYear={onValueChange} {...props} />
      <div className="cr-calendar-uk">
        {curYearSelectable && (
          <CrButton onClick={() => onValueChange(dayjs().format("YYYY"))}>This Year {` (${dayjs().format("YYYY")})`}</CrButton>
        )}
        {(yearUnknowable || allUnknowable) && <CrButton onClick={() => onValueChange("UKUK")}>UKUK</CrButton>}
        <CrIconButton color="inner-bordered" onClick={() => onDeleteDate && onDeleteDate()} icon="EraseTool" />
      </div>
    </div>
  );
}

CrYearExt.defaultProps = {
  allUnknowable: false,
  yearUnknowable: false,
};
